module.exports = __webpack_public_path__ + "img/mailchimp.233bb579.png";